import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import Popup from '../Common/Popup';

/**
 * The `IncubationStatusFilter` function is a React component that renders a filter for selecting
 * incubation status options.
 * @returns a JSX element.
 */
function IncubationStatusFilter({ IncubationStatusOptions, setIncubationStatusOptions, customPathname, isPopupOpen, setIsPopupOpen }) {
    const { IncubationStatus, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.incubationStatus?.map(value => value.id) ?? [];
        setIncubationStatusOptions(IncubationStatus?.map(industry => ({ ...industry, isChecked: industryIds.includes(parseInt(industry.id)) })))
    }, [IncubationStatus, customPathname, refineSearchFilters, setIncubationStatusOptions])


    const handleIncubationStatusChange = (e) => {
        const { name, checked, id, filteredIds } = e.target;
        let currentIncubationStatus = [];
    
        if (name === "allSelect") {
            currentIncubationStatus = IncubationStatusOptions.map((status) =>
                ({ ...status, isChecked: checked })
            );
        } else if (name === "filteredSelect" && filteredIds) {
            currentIncubationStatus = IncubationStatusOptions.map((status) => {
                if (filteredIds.includes(status.id)) {
                    return { ...status, isChecked: checked };
                }
                return status;
            });
        } else {
            currentIncubationStatus = IncubationStatusOptions.map((status) =>
                status.id === parseInt(id) ? { ...status, isChecked: checked } : status
            );
        }
    
        setIncubationStatusOptions(currentIncubationStatus);
    };
    

    const len = IncubationStatusOptions?.filter(option => option.isChecked)?.length ?? 0

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-lg px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 w-full md:w-[90%] text-left flex items-center justify-between"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">Status <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {IncubationStatusOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {len > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {len}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-2">
                        <MultiSelectEntity
                            handleEntityChange={handleIncubationStatusChange}
                            primaryEntity={IncubationStatusOptions}
                            showAll={false}
                        />
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default IncubationStatusFilter